/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatHasTicketQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ThreatHasTicketQueryOperator");
    }

    getFixupPrototypeFunction() { return ThreatHasTicketQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ThreatHasTicketQueryOperator>): ThreatHasTicketQueryOperator {
        let obj = Object.assign(new ThreatHasTicketQueryOperator(), model);
        ThreatHasTicketQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatHasTicketQueryOperator>): ThreatHasTicketQueryOperator {
        if (!model) return null;
        return ThreatHasTicketQueryOperator.newInstance(<ThreatHasTicketQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatHasTicketQueryOperator) {
        if (!obj) return;

        models.ThreatHasTicketQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatHasTicketQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatHasTicketQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * True returns only threats that have an ITSM ticket; false returns only those without.
     */
    has_ticket: boolean;

}
